module.exports = {"version":"0.0.0"}


//////////////////
// WEBPACK FOOTER
// ./project.json
// module id = tQPw
// module chunks = 0